import { useRoutes } from "react-router-dom";
import CheckListBuilder from "./ChecklistConfiguration/Component/checklistBuilder";
import ChecklistBuilderForm from "./ChecklistConfiguration/Component/checklistBuilderForm";

// Category module removed from PDI — no longer needed here.
// If Category is used elsewhere in the system, its files remain but are not routed here.

const ConfigurationIndex = () => {
  const router = useRoutes([
    {
      // Default route now goes straight to Templates list
      index: true,
      element: <CheckListBuilder />,
    },
    {
      path: "checklist-builder",
      element: <CheckListBuilder />,
    },
    {
      path: "checklist-builder/*",
      children: [
        { index: true,        element: <CheckListBuilder /> },
        { path: "add",        element: <ChecklistBuilderForm mode="add" /> },
        { path: "edit/:uuid", element: <ChecklistBuilderForm mode="edit" /> },
        { path: "view/:uuid", element: <ChecklistBuilderForm mode="view" /> },
      ],
    },
  ]);
  return <div>{router}</div>;
};

export default ConfigurationIndex;